import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = ({ onLogin }) => {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        mobile,
        password
      });

      onLogin(response.data.token, response.data.user);
      toast.success("Login successful!");
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="bg-white p-8 rounded-lg border-2 border-[#e2e8f0] shadow-lg">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-extrabold mb-2 leading-tight" style={{fontFamily: 'Manrope, sans-serif', color: '#dc2626'}}>
              Adams Events Rental Services
            </h1>
            <p className="text-sm text-[#64748b] italic">Quotation Management</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="mobile" className="text-base font-medium text-[#0f172a] mb-2 block">
                Mobile Number
              </Label>
              <Input
                id="mobile"
                type="tel"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                placeholder="Enter mobile number"
                className="h-12 text-base"
                required
                data-testid="login-mobile-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-base font-medium text-[#0f172a] mb-2 block">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="h-12 text-base"
                required
                data-testid="login-password-input"
              />
            </div>

            <Button
              type="submit"
              className="w-full h-12 bg-[#dc2626] hover:bg-[#b91c1c] text-white font-semibold text-base"
              disabled={loading}
              data-testid="login-submit-btn"
            >
              {loading ? "Logging in..." : "Login"}
            </Button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default Login;